import styles from "../styles/page.module.css";
import ChartCategory from "./ChartCategory";

const StatisticsCharts = ({ surveyStatistic }) => {
  const allQuestions = surveyStatistic?.surveyPages
    .map((page) => page.surveyQuestions)
    .flat();

  return (
    <section className={styles["statistics-charts"]}>
      {surveyStatistic?.question_initial.length > 0 && (
        <ChartCategory
          title="Datos de usuario"
          questions={surveyStatistic?.question_initial}
        />
      )}

      <ChartCategory
        title="Estadísticas de encuesta"
        questions={allQuestions}
      />
    </section>
  );
};

export default StatisticsCharts;
